import { type DetailedRoute, type MinimalTarget } from '@/generated/model';
import { type SelectedRoute } from '@/types';

export function convertRouteToSelected(route: DetailedRoute, selectedTarget: MinimalTarget): SelectedRoute {
  return {
    id: route.id,
    target: selectedTarget,
    fromTimeMicros: route.startPosition.timeMicros,
    toTimeMicros: route.stopPosition.timeMicros,
  };
}

export function convertRouteListToSelected(
  routes: DetailedRoute[] | undefined,
  selectedTarget: MinimalTarget | undefined
): SelectedRoute[] {
  if (!routes || !selectedTarget) {
    return [];
  }
  return routes.map((route) => convertRouteToSelected(route, selectedTarget));
}
